import GuruTree from "../components/GuruTree";
import ShriAlokAnandTripathi from '../assets/images/Shri Alok Anand Tripathi.jpeg';
export default function FoundersPage() {
  

  return (
    <>
   { /*<div className="overflow-x-scroll p-4 bg-custom-ivory">
      <h1 className="text-4xl py-3 text-center text-custom-maroon font-bold">Lineage Tree</h1>
    <GuruTree />
  </div>*/}
    <div className="bg-custom-ivory text-custom-yellow min-h-screen py-10 px-5">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-4xl font-bold mb-8">Fifth Custodian</h1>
        <h2 className="text-2xl font-bold py-2">Shri Alok Anand Tripathi</h2>
        <div className="flex flex-col justify-center items-center px-4 md:px-8">
          <img src={ShriAlokAnandTripathi} alt="Shri Alok Anand Tripathi" className="w-64 h-64 object-cover rounded-lg shadow-md" />
        </div>
      </div>
      <div className="w-[90%] mx-auto text-lg leading-relaxed py-4">
        <p>
          Shri Alok Anand Tripathi is the 5th custodian and current head of Daiv-Prashna, a distinguished figure in the world of Vedic astrology and spiritual guidance. With 18 years of experience, Alok Ji has built a reputation as a mystical astrologer, renowned not only for his expertise but also for his deep commitment to social service and his rich guru lineage.
        </p>
        <p>
         His social service is a cornerstone of his work. For over 15 years, he has been offering free consultations to individuals of all castes and financial backgrounds, ensuring that astrology and spiritual guidance are accessible to everyone.
        </p>
        <p>
          His method of Manual Vedic Horoscope Making, using over 102 years of Vedic panchang data, is mystical in nature. His intuitive ability to craft horoscopes and offer precise predictions by simply observing a person’s appearance, caste, and financial status speaks to his profound connection with the spiritual and astrological realms.
        </p>
        <p>
          At the heart of his practice lies his guru lineage, which is an essential part of his spiritual identity. He is a direct disciple of Shree Neelkanth Shastri, who was a disciple of Shri Gopinath Kaviraj, and ultimately a direct disciple of Shri Vishuddhanand Paramhansa. This unbroken chain of spiritual masters provides Alok Ji with a rich and sacred legacy.
        </p>
        <p>
          In addition to his spiritual and astrological work, Alok Ji is an accomplished entrepreneur, owning GGC Clothing Company and Nivesh Jano. His dedication to social service and spiritual enlightenment truly defines his legacy.
        </p>
        <p>
          Alok Anand Tripathi Ji's vision for Daiv-Prashna is to offer spiritual guidance and astrological wisdom to a global audience, with a focus on uplifting individuals through both practical advice and spiritual transformation.
        </p>
      </div>
    </div></>
  );
}
